import './config';
import 'babel-polyfill';
import 'es6-promise/auto';
//import 'es7-shim'
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueI18n from 'vue-i18n';
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import Fullscreen from 'vue-fullscreen';
import VueHighlightJS from 'vue-highlightjs';
import 'highlight.js/styles/color-brewer.css';
import vClickOutside from 'v-click-outside';
import VirtualList from 'vue-virtual-scroll-list';
import VueResize from 'vue-resize';
import 'vue-resize/dist/vue-resize.css';
import VueGoodTable from 'vue-good-table';
import VueFloatLabel from 'vue-float-label';
import V2Table from 'v2-table';
import 'v2-table/dist/index.css';
import Vuebar from 'vuebar';

import { StatusIndicator } from 'vue-status-indicator';
//import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VuePerfectScrollbar from './components/vue-ps';
import * as Vue2Leaflet from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
//import './assets/scss/element-variables.scss'
import './assets/scss/global.scss';
import 'flex.box';
import 'animate.css';
import '../node_modules/mdi/scss/materialdesignicons.scss';
import Affix from './directives/affix';
import App from './App.vue';
import router from './router/' ;
import store from './store' ;
import i18n_messages from './i18n.json';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vue2Filters from 'vue2-filters';
import * as Sentry from '@sentry/browser';;
import * as Integrations from '@sentry/integrations';
import {Tracer} from "@/api/common/Tracer";
import {AppBuild} from "@/init/AppBuild";

Vue.config.productionTip = false;

Vue.use(Vuelidate);

Vue.component('StatusIndicator', StatusIndicator);

Vue.use(VueFloatLabel);
Vue.use(VueResize);
Vue.use(Fullscreen);
Vue.use(VueI18n);
Vue.use(Element, {locale});
Vue.use(VueHighlightJS);
Vue.use(vClickOutside);
Vue.use(Viewer);

Vue.directive('affix', Affix);
Vue.use(VueGoodTable);
Vue.use(V2Table);
Vue.use(VueAxios, axios);
Vue.use(Vue2Filters);
Vue.use(Vuebar);


Vue.component('vue-scroll', VuePerfectScrollbar);
Vue.component('vue-virtual-list', VirtualList);
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ 
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'), 
	iconUrl: require('leaflet/dist/images/marker-icon.png'), 
	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
Vue.component('l-map', Vue2Leaflet.LMap);
Vue.component('l-marker', Vue2Leaflet.LMarker);
Vue.component('l-tile-layer', Vue2Leaflet.LTileLayer);
const i18n = new VueI18n({ locale: 'us', messages:i18n_messages });


Vue.prototype.$config = window.config;
window.tracer = new Tracer();

let appBuild = new AppBuild();
appBuild.setDate(process.env.VUE_APP_BUILD_DATE);
appBuild.setEnv(process.env.VUE_APP_ENVIRONMENT);
appBuild.setDebugMode(process.env.VUE_APP_IS_DEBUG_MODE);
appBuild.setCommitHash(process.env.VUE_APP_COMMIT_HASH);
appBuild.setStamp(process.env.VUE_APP_BUILD_STAMP);
appBuild.setVersion(process.env.VUE_APP_VERSION);
appBuild.setBuildNumber(process.env.VUE_APP_CI_BUILD);

/**
 * Build information
 * @type {AppBuild}
 */
window.$build = appBuild;

Tracer.current.info(`[i-140550] Version ${appBuild.version} (${appBuild.shortCommitHash}) build on ${appBuild.date}`);
if (appBuild.env === "Production"){
	Tracer.current.info("Production Version");
}

if (window.appInstanceId) {
	Vue.prototype.$instanceId = window.appInstanceId;
}
else{
	Vue.prototype.$instanceId = '';
	window.appInstanceId = '';
}

if (!window.config.isLocal) {

	try {
		tracer.debug("[d668250] Initializing Sentry");
		Sentry.init({
			dsn: window.config.sentry.url,
			environment: window.config.environment,
			release: window.config.version,
			integrations: [
				new Sentry.Integrations.Vue({
					Vue,
					attachProps: window.config.sentry.attachProps
				})
			],
		});
	}
	catch {
	   tracer.info("[i747917] Error setting up Sentry - Error ignored. Continuing...");
	}

}

window.tracer.tag("instanceId", window.appInstanceId);
window.tracer.tag("correlationId", window.config.correlationId);

let app = new Vue({
	i18n,
	router,
	store,
	validations: {},
	render: h => h(App)
}).$mount('#app');

Vue.prototype.$tracer = window.tracer;
// allow me to access the app.
window.app = app;


